if (!customElements.get('press-element')) {
  customElements.define(
    'press-element',
    class PressElement extends HTMLElement {
      constructor() {
        super();
        this.attempts = 0; // Keep track of how many times we've checked
      }

      connectedCallback() {
        this.testimonials = this.querySelector('.press-testimonials');
        this.thumbs = this.querySelector('.press-thumbs');
        this.sectionId = this.dataset.sectionId;
        this.testimonialsSlider = this.testimonials.querySelector('.swiper');
        this.thumbsSlider = this.thumbs.querySelector('.swiper');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
      
        window.addEventListener('resize', () => {
          this.updateGap();
          this.forceUpdate(); 
        });

        // --- THE FIX: Start the polling loop ---
        this.waitForLayoutToFinish();
      }

      waitForLayoutToFinish() {
        // Grab the first thumbnail slide
        const testSlide = this.thumbsSlider.querySelector('.swiper-slide');
        
        // Check if the browser has physically rendered it with a width > 0
        if (testSlide && testSlide.offsetWidth > 0) {
          // Success! The CSS is applied. Boot up Swiper.
          this.updateGap();
          this.init();
          
          // One final safety update after 200ms
          setTimeout(() => this.forceUpdate(), 200);
          
        } else if (this.attempts < 50) {
          // If it's still 0px, wait 100ms and check again (up to 50 times / 5 seconds)
          this.attempts++;
          setTimeout(() => this.waitForLayoutToFinish(), 100);
        } else {
          // Failsafe: If 5 seconds pass and it's still 0, just try to initialize anyway
          this.updateGap();
          this.init();
        }
      }

      forceUpdate() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.update();
        }
        if (this.thumbsInstance && this.thumbsInstance.slider) {
          this.thumbsInstance.slider.update();
        }
      }

      init() {
        this.destroySlider();
        this.initSlider();
      }

      updateGap() {
        const columnGap = window.getComputedStyle(this.thumbs).getPropertyValue('--f-column-gap');
        this.columnGap = columnGap;
      }

      setSliderOptions() {
        const spaceBetween = parseFloat((this.columnGap || '0rem').replace('rem', '')) * 10;

        this.testimonialsOptions = {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          threshold: 1,
          grabCursor: true,
          observer: true,
          observeParents: true,
        };
      
        this.thumbsOptions = {
          slidesPerView: 'auto',
          spaceBetween: spaceBetween,
          threshold: 1,
          freeMode: true,
          centeredSlides: true,
          slideToClickedSlide: true,
          loop: true,
          observer: true,
          observeParents: true,
        };
      }

      initSlider() {
        this.setSliderOptions();
      
        const modules = [FoxTheme.Swiper.Thumbs];
      
        this.thumbsInstance = new FoxTheme.Carousel(this.thumbsSlider, this.thumbsOptions, modules);
        this.thumbsInstance.init();
      
        this.testimonialsOptions.thumbs = {
          swiper: this.thumbsInstance.slider,
        };
      
        this.sliderInstance = new FoxTheme.Carousel(this.testimonialsSlider, this.testimonialsOptions, modules);
        this.sliderInstance.init();
      
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { realIndex, thumbs } = swiper;
          if (thumbs && thumbs.swiper) {
            thumbs.swiper.slideToLoop(realIndex);
          }
        });

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            if (this.sliderInstance && this.sliderInstance.slider) {
              this.sliderInstance.slider.slideToLoop(index);
            }
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance) return;
        if (this.sliderInstance.slider) this.sliderInstance.slider.destroy();
        this.sliderInstance = false;

        if (this.thumbsInstance && this.thumbsInstance.slider) this.thumbsInstance.slider.destroy();
        this.thumbsInstance = false;
      }
    }
  );
}